<template>
<div style="height:100vh; overflow-y: scroll;">
<div class="outer">
<p><strong>&nbsp;</strong></p>
<h1 style="text-align: center;margin-bottom: 20px">《心理亦笙》咨询预约协议</h1>
<p><strong>&nbsp;</strong></p>
<p>本协议由网络用户（以下称&ldquo;用户&rdquo;）与亦笙信息技术（深圳）有限公司开发《心理亦笙》平台（以下称&ldquo;心理亦笙&rdquo;）共同缔结，本协议具有合同效力。</p>
<p>一、协议内容</p>
<p>1、本协议内容包括协议正文及所有心理亦笙已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。除另行明确声明外，心理亦笙提供的任何服务（以下称为&ldquo;心理亦笙平台服务&rdquo;）均受本协议约束。</p>
<p>2、用户应当在使用心理亦笙平台服务之前认真阅读全部协议内容，<strong>对于协议中以加粗字体显示的内容，您应重点阅读。</strong>如您对协议有任何疑问的，应向心理亦笙咨询。但无论您在使用心理亦笙平台服务之前是否事实上认真阅读了本协议的内容，只要您使用心理亦笙平台服务，则本协议即对您产生约束，届时您不应以未阅读本协议的内容或者未获得心理亦笙对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</p>
<p>3、用户应当承诺接受并遵守本协议的约定。如果您不同意本协议的约定，应立即停止注册程序或停止使用心理亦笙平台服务。</p>
<p>4、心理亦笙有权根据需要不时地制订、修改本协议或各类规则，并以网站公示的方式进行公告，不再单独通知您。变更后的协议和规则一经在网站公布后，立即自动生效。如您不同意相关变更，应当立即停止使用心理亦笙平台服务。您继续使用心理亦笙平台服务的，即表示您接受经修订的协议和规则。</p>

<p>二、平台服务</p>
<p>1、通过心理亦笙及其关联公司提供的心理亦笙平台服务和其它服务，会员可在心理亦笙平台上获得针对本人的心理、健康咨询意见、指导及建议；可发布、上传个人信息、医疗检查（检验）信息、病历或处方信息、医疗需求信息、健康需求信息及其他心理亦笙许可的信息；对其他会员进行评价；参加心理亦笙组织的活动以及使用其它信息服务及技术服务等。上述服务包括可能的收费项目，您在预约相关服务之前可能需要支付相关费用。</p>
<p>2、您在心理亦笙平台上与其他会员发生纠纷时，一旦您或其它会员任一方或双方共同提交心理亦笙要求调处，则心理亦笙有权根据单方判断做出调处决定，您了解并同意接受心理亦笙的判断和调处决定，该决定将对您具有法律约束力。</p>
<p><strong>三、平台服务使用规范</strong></p>
<p><strong>1</strong><strong>、在心理亦笙平台上使用心理亦笙各种服务过程中，您承诺遵守以下约定：</strong></p>
<p><strong>a</strong><strong>）在使用心理亦笙平台服务过程中实施的所有行为均遵守国家法律、法规等规范性文件及心理亦笙平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保心理亦笙免于因此产生任何损失。</strong></p>
<p><strong>b</strong><strong>）在接受各种服务的过程中，遵守诚实信用原则，不采取不正当行为，不扰乱心理亦笙的正常运营秩序，不从事与心理亦笙服务无关的行为。</strong></p>
<p><strong>c</strong><strong>）不发布、上传国家禁止的各种信息，不发布、上传涉嫌侵犯他人知识产权或其它合法权益的各种信息，不发布违背社会公共利益或公共道德或心理亦笙认为不适合在心理亦笙平台上使用的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息。</strong></p>
<p><strong>d</strong><strong>）</strong> <strong>不以虚构或歪曲事实的方式不当评价其他会员；不得盗用他人账户、用户名，由此行为造成的后果自负。</strong></p>
<p><strong>e</strong><strong>）</strong> <strong>不对心理亦笙平台上的任何数据作商业性利用，包括但不限于在未经心理亦笙事先书面同意的情况下，以复制、传播等任何方式使用心理亦笙平台上储存的资料；</strong></p>
<p><strong>f</strong><strong>）</strong> <strong>不使用任何装置、软件或例行程序干预或试图干预心理亦笙平台的正常运作或正在心理亦笙平台上进行的任何交易、活动。您不得采取任何将导致不合理的庞大数据负载加诸于心理亦笙平台网络设备的行动。</strong></p>
<p><strong>2.</strong><strong>您了解并同意：</strong></p>
<p><strong>a</strong><strong>）</strong> <strong>心理亦笙有权对您是否违反上述承诺做出单方认定，并根据单方认定结果适用规则予以处理或终止向您提供服务，且无须征得您的同意或提前通知予您；</strong></p>
<p><strong>b</strong><strong>）</strong> <strong>经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为，或者心理亦笙根据自身的判断，认为您的行为涉嫌违反本协议或规则的条款或涉嫌违反法律法规的规定的，则心理亦笙有权在心理亦笙平台上公示您的该等涉嫌违法或违约行为及心理亦笙已对您采取的措施；</strong></p>
<p><strong>c</strong><strong>）</strong> <strong>对于您在心理亦笙平台上发布的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议和</strong><strong>/</strong><strong>或规则的信息，心理亦笙有权不经通知您即予以删除；</strong></p>
<p><strong>d</strong><strong>）</strong> <strong>对于您在心理亦笙平台上实施的行为，包括您未在心理亦笙平台上实施但已经对心理亦笙平台及其用户产生影响的行为，心理亦笙有权单方认定您行为的性质及是否构成对本协议和</strong><strong>/</strong><strong>或规则的违反，并据此作出相应措施。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据而承担的不利后果；</strong></p>
<p><strong>e</strong><strong>）</strong> <strong>对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保心理亦笙免于因此产生损失或增加费用；</strong></p>
<p><strong>f</strong><strong>）</strong> <strong>如您涉嫌违反有关法律或者本协议之规定，使心理亦笙遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿心理亦笙因此造成的损失及（或）发生的费用，包括合理的律师费用。</strong></p>
<p>四、隐私政策</p>
<p>1、心理亦笙将在平台上公布并不时修订隐私权政策，隐私权政策构成本协议的有效组成部分。</p>
<p>2、心理亦笙承诺不公开或透露用户的个人资料，您的个人资料将仅限于我们网站和您所预约的咨询师、医师，以便我们能为您提供更完善的服务，包括但不限于向用户发出活动和服务信息等。</p>
<p>3、您了解并同意，因会员本人的需要、您本人同意让第三方共享资料、法律或其他合法程序的要求、服务条款的改变或修订以及我们发现你违反了心理亦笙的服务条款使用规定等，心理亦笙有权向第三方提供您在心理亦笙平台填写的注册信息、发布或上传的纪录等必要信息。如您涉嫌侵犯他人知识产权，则心理亦笙亦有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供您必要的身份信息及相关证据。</p>
<p>4、除上述原因外，心理亦笙将对您所提供的资料进行严格的管理和保护，心理亦笙将尽可能采用必要的技术手续，防止您的个人资料丢失、被盗用或遭篡改。</p>
<p>五、责任范围和责任限制</p>
<p><strong>1</strong><strong>、心理亦笙并非医疗机构，任何在心理亦笙注册的医师、咨询师等均非在心理亦笙执业。上述人员不得在心理亦笙服务平台上提供医疗诊疗服务及类似服务，您亦不得要求上述人员提供任何形式的医疗诊疗服务。上述人员出具各类意见、建议均为其本人的意见，心理亦笙仅为沟通、服务平台，对具体意见、建议不承担任何责任。</strong></p>
<p>2、心理亦笙负责按&ldquo;现状&rdquo;和&ldquo;可得到&rdquo;的状态向您提供心理亦笙平台服务。但心理亦笙对心理亦笙平台服务不作任何明示或暗示的保证，包括但不限于心理亦笙平台服务的适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途。同时，心理亦笙也不对心理亦笙平台服务所涉及的技术及信息的有效性、准确性、正确性、可靠性、质量、稳定、完整和及时性作出任何承诺和保证。</p>
<p>3、您了解心理亦笙平台上的信息系用户自行发布，且可能存在风险和瑕疵。心理亦笙平台仅作为交易地点。心理亦笙平台仅作为您获取服务或信息、物色医师、就服务进行协商的场所，但心理亦笙无法控制交易所涉及的服务的质量、安全或合法性，信息的真实性或准确性，以及交易各方履行其在服务中各项义务的能力。您应自行谨慎判断并确定相关服务、信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。</p>
<p>4、除非法律法规明确要求，或出现以下情况，否则，心理亦笙没有义务对所有用户的注册数据、服务及信息、交易行为以及有关的其它事项进行事先审查：</p>
<p>a）心理亦笙有合理的理由认为特定会员及具体事项可能存在重大违法或违约情形。</p>
<p>b）心理亦笙有合理的理由认为用户在心理亦笙平台的行为涉嫌违法或不正当。</p>
<p>5、心理亦笙及其关联公司有权受理您与其他会员因交易产生的争议，并有权单方判断与该争议相关的事实及应适用的规则，进而作出处理决定。该处理决定对您有约束力。</p>
<p>您理解并同意，心理亦笙并非司法机构，仅能以普通人的身份对证据进行鉴别，心理亦笙及其关联公司对争议的调处完全是基于您的委托，心理亦笙无法保证争议处理结果符合您的期望，也不对争议调处结论承担任何责任。如您因此遭受损失，您同意自行向受益人索偿。</p>
<p>6、您了解并同意，心理亦笙不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿 (无论心理亦笙是否已被告知该等损害赔偿的可能性） ：</p>
<p>a）使用或未能使用心理亦笙平台服务；</p>
<p>b）第三方未经批准的使用您的账户或更改您的数据；</p>
<p>c）通过心理亦笙平台服务获取任何数据、信息、意见、建议等产生的费用及损失；</p>
<p>d）您对心理亦笙平台服务的误解；</p>
<p>e）任何非因心理亦笙的原因而引起的与心理亦笙平台服务有关的其它损失。</p>
<p>6、不论在何种情况下，心理亦笙均不对由于信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。</p>
<p>六、支付方式</p>
<p><strong>心理亦笙的网上支付平台是通过国内各大银行的支付网关或第三方支付平台进行操作，用户在线支付时将直接进入其指定银行或第三方支付平台的官方网站，本网站并不收集用户的任何银行卡号、密码等资料。用户应当对其银行账号、密码以及支付行为承担全部的风险与责任。</strong></p>
<p>七、协议终止</p>
<p>1、您同意，心理亦笙有权自行全权决定以任何理由不经事先通知的中止、终止向您提供部分或全部心理亦笙平台服务，暂时冻结或永久冻结（注销）您的账户，且无须为此向您或任何第三方承担任何责任。</p>
<p>2、出现以下情况时，心理亦笙有权直接以注销账户的方式终止本协议:</p>
<p>a）心理亦笙终止向您提供服务后，您涉嫌再一次直接或间接或以他人名义注册为心理亦笙用户的；</p>
<p>b）您提供的电子邮箱不存在或无法接收电子邮件，且没有其他方式可以与您进行联系的；</p>
<p>c）您注册信息中的主要内容不真实或不准确或不及时或不完整；</p>
<p>d）本协议（含规则）变更时，您明示并通知心理亦笙不愿接受新的服务协议的；</p>
<p>e）其它心理亦笙认为应当终止服务的情况。</p>
<p>3、您有权向心理亦笙要求注销您的账户，经心理亦笙审核同意的，心理亦笙注销（或永久冻结）您的账户，届时，您与心理亦笙基于本协议的合同关系即终止。您的账户被注销（或永久冻结）后，心理亦笙没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。</p>
<p>4、您同意，您与心理亦笙的合同关系终止后，心理亦笙仍享有下列权利</p>
<p>a）继续保存您的注册信息及您使用心理亦笙平台服务期间的所有交易信息；</p>
<p>b）您在使用心理亦笙平台服务期间存在违法行为或违反本协议和/或规则的行为的，心理亦笙仍可依据本协议向您主张权利；</p>
<p>5、心理亦笙中止或终止向您提供心理亦笙平台服务后，对于您在服务中止或终止之前的交易行为依下列原则处理，您应独力处理并完全承担进行以下处理所产生的任何争议、损失或增加的任何费用，并应确保心理亦笙免于因此产生任何损失或承担任何费用：</p>
<p>a）您在服务中止或终止之前已经上传至心理亦笙平台信息，心理亦笙有权在中止或终止服务的同时删除此项信息；</p>
<p>b）您在服务中止或终止之前已经与其他会员达成服务预约，但尚未实际履行的，心理亦笙有权删除该预约服务的相关信息；</p>
<p>c）您在服务中止或终止之前已经与其他会员达成服务预约且已部分履行的，心理亦笙可以不删除该项预约，但心理亦笙有权在中止或终止服务的同时将相关情形通知您的交易对方，对方有权选择继续履行或终止履行。</p>
<p>八、其他条款</p>
<p>1、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。</p>
<p>2、因本协议产生之争议，应依照中华人民共和国法律予以处理，并以深圳市龙华区人民法院为管辖法院。</p>


</div>
<div>
<footerCommon></footerCommon>
</div>
</div>
</template>

<script>
    export default {
        name: "agreementConsult",
        components: {
            'footerCommon': () => import('../footerCommon'),
        },
        mounted() {
            this.$router.app.$children[0].$data.type = 'none';
        }
    }
</script>

<style lang="scss" scoped>
	.outer{
		padding: 40px;
		p.bold{font-weight: bold}
		p.right{text-align: right;}
		p{
			text-indent: 2rem;
			font-size: 14px;
			color: #434343;
			line-height: 2;
			a{
				text-decoration: underline;
			}
		}
	}
</style>